import { OverlineTitle } from '@repo/ui';
import { FormikValues } from 'formik';
import React from 'react';
import { Input } from 'reactstrap';

interface IAppProfessionalSettingsSectionProps {
  validation: FormikValues;
}

export const AppProfessionalSettingsSection = ({
  validation,
}: IAppProfessionalSettingsSectionProps) => {
  return (
    <React.Fragment>
      <div className="mt-2">
        <OverlineTitle title="Configurações app profissional" />
      </div>

      <div className="form-check mb-3">
        <Input
          id="appProfessionalShowFeedbackValidation"
          type="checkbox"
          name="setting.appProfessionalShowFeedbackValidation"
          className="form-check-input"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          checked={
            validation?.values?.setting?.appProfessionalShowFeedbackValidation
          }
        />

        <label
          className="form-check-label"
          htmlFor="appProfessionalShowFeedbackValidation"
        >
          Dar feedback ao estudante ao validar/rejeitar atividades
        </label>
      </div>

      <div className="form-check mb-3">
        <Input
          id="appProfessionalShowDailyWorkloadByStudentReport"
          type="checkbox"
          name="setting.appProfessionalShowDailyWorkloadByStudentReport"
          className="form-check-input"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          checked={
            validation?.values?.setting
              ?.appProfessionalShowDailyWorkloadByStudentReport
          }
        />

        <label
          className="form-check-label"
          htmlFor="appProfessionalShowDailyWorkloadByStudentReport"
        >
          Relatório de Carga Horária Diária por Estudante
        </label>
      </div>

      <div className="form-check mb-3">
        <Input
          id="appProfessionalSubtaskRequiredByDefault"
          type="checkbox"
          name="setting.appProfessionalSubtaskRequiredByDefault"
          className="form-check-input"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          checked={
            validation?.values?.setting?.appProfessionalSubtaskRequiredByDefault
          }
        />

        <label
          className="form-check-label"
          htmlFor="appProfessionalSubtaskRequiredByDefault"
        >
          Definir subtarefa obrigatória como padrão nos agendamentos
        </label>
      </div>

      <div className="form-check mb-3">
        <Input
          id="appProfessionalShowFaultInValidation"
          type="checkbox"
          name="setting.appProfessionalShowFaultInValidation"
          className="form-check-input"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          checked={
            validation?.values?.setting?.appProfessionalShowFaultInValidation
          }
        />

        <label
          className="form-check-label"
          htmlFor="appProfessionalShowFaultInValidation"
        >
          Exibir opção de falta na validação da atividade
        </label>
      </div>

      <div className="form-check mb-3">
        <Input
          id="defaultEvaluationDisplayable"
          type="checkbox"
          name="setting.defaultEvaluationDisplayable"
          className="form-check-input"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          checked={
            validation?.values?.setting?.defaultEvaluationDisplayable
          }
        />

        <label
          className="form-check-label"
          htmlFor="defaultEvaluationDisplayable"
        >
          Definir opção de 'Somente mostrar avaliação ao estudante após liberação no sistema' marcado por padrão
        </label>
      </div>
    </React.Fragment>
  );
};
